import { Alert, type AlertColor } from '@mui/material';

interface StatusAlertProps {
  message: string;
  type?: AlertColor;
}

export default function StatusAlert({ message, type = 'info' }: StatusAlertProps) {
  if (!message) return null;
  return (
    <Alert severity={type} sx={{ mb: 2 }}>
      {message}
    </Alert>
  );
}
